export default __webpack_public_path__ + "static/media/ic-safe-folder.c231c880.svg";